var _defs, _path, _path2, _path3, _circle, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCampaigns(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 170.53 164.76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#c1d6df;}.cls-1,.cls-2,.cls-3,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9{fill-rule:evenodd;}.cls-2{fill:#e6e6e5;}.cls-3{fill:#ff9a83;}.cls-4,.cls-9{fill:#fff;}.cls-5{fill:#ffe079;}.cls-6{fill:#f6851f;}.cls-7{fill:#fcb13c;}.cls-8{fill:#6ad3aa;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M33.51,29.58h43.2a8.17,8.17,0,0,1,8.14,8.14V133a8.17,8.17,0,0,1-8.14,8.14H33.51A8.17,8.17,0,0,1,25.37,133V37.72A8.17,8.17,0,0,1,33.51,29.58Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M35.4,29.58H74.82v4.06a4.52,4.52,0,0,1-4.51,4.51H39.91a4.52,4.52,0,0,1-4.51-4.51Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M121.14,67h26.27a5.27,5.27,0,0,1,5.25,5.26V98.5a5.27,5.27,0,0,1-5.25,5.26H121.14a5.27,5.27,0,0,1-5.25-5.26V72.24A5.27,5.27,0,0,1,121.14,67Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 134.24,
    cy: 85.33,
    r: 9.88
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M112.93,112.51H139.2a5.28,5.28,0,0,1,5.25,5.26V144a5.27,5.27,0,0,1-5.25,5.25H112.93a5.26,5.26,0,0,1-5.25-5.25V117.77a5.27,5.27,0,0,1,5.25-5.26Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M122.38,142.37a4.29,4.29,0,1,0-4.28-4.28A4.29,4.29,0,0,0,122.38,142.37Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M71.62,73.26l.45-.19L96.83,62.79v41.15L72.07,93.65l-.45-.18Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M71.62,73.26H61.52a10.11,10.11,0,0,0,0,20.21h10.1Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M71.62,93.47H62.34l1.89,16.72,7.39,3.49Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M112.93,21.46H139.2a5.27,5.27,0,0,1,5.25,5.25V53a5.28,5.28,0,0,1-5.25,5.25H112.93A5.27,5.27,0,0,1,107.68,53V26.71a5.26,5.26,0,0,1,5.25-5.25Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M136.82,39.84l-18,10.37V29.48Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaigns);
export default __webpack_public_path__ + "static/media/Campaigns.d5a979c2fc1fdf1b2f88b662d686ec59.svg";
export { ForwardRef as ReactComponent };